import { endpointsList } from '@/helpers';
import axios from 'axios';
import { IContentTypeField } from 'types';
import { ref } from 'vue';

export function useGetContentTypeFields(
  contentTypeId: string,
  includeUniversalMappingFields = false,
  autoFetch = true,
) {
  const contentTypeFields = ref<IContentTypeField[]>([]);

  async function getContentTypeFields() {
    const response = await axios.get<IContentTypeField[]>(
      endpointsList.contentTypeMappings.getContentTypeById(
        contentTypeId,
        includeUniversalMappingFields,
      ),
    );
    contentTypeFields.value = response.data;
  }

  if (autoFetch) {
    getContentTypeFields();
  }

  return { contentTypeFields, getContentTypeFields };
}
